import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/lib/toast";
import { AuthShell, Field, AuthButton } from "@/pages/auth/AuthShell";

export default function Login() {
  const { colors } = useTheme();
  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.show("Pop in your email and password.");
      return;
    }
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/", { replace: true });
    } catch (err) {
      toast.show(err.message);
    } finally {
      setLoading(false);
    }
  };

  const linkStyle = { color: colors.brandSecondary, fontFamily: fonts.text, fontWeight: 700, textDecoration: "none" };

  return (
    <AuthShell>
      <h2 style={{ color: colors.onSurface, fontSize: 22, fontFamily: fonts.display, fontWeight: 700, margin: "0 0 4px" }}>Welcome back 🖤</h2>
      <p style={{ color: colors.muted, fontSize: 14, fontFamily: fonts.text, margin: "0 0 20px" }}>Sign in to your Rep HQ.</p>
      <form onSubmit={submit}>
        <Field label="Email" testId="login-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
        <Field label="Password" testId="login-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        <div style={{ textAlign: "right", marginBottom: 18, marginTop: -6 }}>
          <Link to="/forgot-password" data-testid="forgot-link" style={{ ...linkStyle, fontSize: 13 }}>Forgot password?</Link>
        </div>
        <AuthButton loading={loading} data-testid="login-submit">Sign in</AuthButton>
      </form>
      <p style={{ color: colors.muted, fontSize: 14, textAlign: "center", marginTop: 20, fontFamily: fonts.text }}>
        New to the team?{" "}
        <Link to="/register" data-testid="go-register" style={linkStyle}>Create your account</Link>
      </p>
    </AuthShell>
  );
}
